<template>
<main class="container-1">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <TabNav :links="routesNav" />
    </div>

    <div class="container-body">

        <header class="layer-head">
            <div class="layer-head__title">
                <h2>{{ layer.name }}</h2>
                <!-- solo cuando la capa ya cargó: antes de eso status es
                     undefined y el badge mostraría "Activa" para cualquiera -->
                <span v-if="layer.id" class="badge" :class="layer.status === false ? 'badge--off' : 'badge--on'">
                    {{ layer.status === false ? 'Desactivada' : 'Activa' }}
                </span>
            </div>
            <p v-if="layer.desc" class="layer-head__desc">{{ layer.desc }}</p>
        </header>

        <div class="info-grid">
            <section class="info-card">
                <h3 class="info-card__title">Información general</h3>
                <dl class="info-card__list">
                    <div class="info-card__row">
                        <dt>Categoría</dt>
                        <dd>{{ category.name || '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Proveedor</dt>
                        <dd>{{ providerLabel }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Fecha de creación</dt>
                        <dd>{{ dateFormatter(layer.created_at) }}</dd>
                    </div>
                </dl>
            </section>

            <section v-if="layer.provider.name === 'geoserver'" class="info-card">
                <h3 class="info-card__title">Datos GeoServer</h3>
                <dl class="info-card__list">
                    <div class="info-card__row">
                        <dt>Nombre de archivo</dt>
                        <dd>{{ layer.provider.geoserverdata.filename || '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Sistema de coordenadas</dt>
                        <dd>{{ layer.provider.geoserverdata.coordinatessystem || '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Espacio de trabajo</dt>
                        <dd>{{ layer.provider.geoserverdata.workspace || '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Almacén de datos</dt>
                        <dd>{{ layer.provider.geoserverdata.datastore || '—' }}</dd>
                    </div>
                </dl>
            </section>

            <section v-else-if="layer.provider.url" class="info-card">
                <h3 class="info-card__title">Origen del servicio</h3>
                <dl class="info-card__list">
                    <div class="info-card__row">
                        <dt>URL</dt>
                        <dd class="info-card__mono">{{ layer.provider.url }}</dd>
                    </div>
                    <div v-if="layer.provider.layerName" class="info-card__row">
                        <dt>Capa del servicio</dt>
                        <dd>{{ layer.provider.layerName }}</dd>
                    </div>
                </dl>
            </section>
        </div>

        <section class="maps-section">
            <h3 class="section-title">
                Mapas con esta capa asignada
                <span v-if="assignedMaps && assignedMaps.length" class="maps-count">{{ assignedMaps.length }}</span>
            </h3>

            <p v-if="assignedMaps && assignedMaps.length === 0" class="maps-empty">
                Esta capa no está asignada a ningún mapa.
            </p>

            <ul v-else class="maps-list">
                <li v-for="item in calculateAssignedMapsPage" :key="item.id">
                    <router-link class="maps-list__item" :to="'/mapas/' + item.id">
                        <font-awesome-icon icon="map" class="maps-list__icon"></font-awesome-icon>
                        <span class="maps-list__name">{{ item.name }}</span>
                        <span class="maps-list__go" aria-hidden="true">›</span>
                    </router-link>
                </li>
            </ul>

            <Pagination
            v-show="totalPages!=0"
            v-bind:totalPages="totalPages"
            v-bind:currentPage="currentPage"
            v-bind:pageSize="pageSize"
            v-on:pagechanged="pageChangedClick"
            >
            </Pagination>
        </section>

    </div>

    <!-- <SideNav
    class="container-sidenav"
    v-bind:links="routesNav"
    >
    </SideNav> -->

</main>
</template>

<script>
// @ is an alias to /src
import SideNav from '@/components/SideNav.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import TabNav from '@/components/TabNav.vue'
import Pagination from '@/components/Pagination.vue'

import {formatter} from '@/components/mixin/formatter.js'
import {pagination} from '@/components/mixin/pagination.js'
import {restLayer} from '@/components/mixin/restLayer.js'
import {restGroup} from '@/components/mixin/restGroup.js'
import {restCategory} from '@/components/mixin/restCategory.js'
import {userGroupName} from '@/components/mixin/userGroupName.js'

const PROVIDER_LABELS = {
    'geoserver': 'GeoServer',
    'arcgis': 'ArcGIS',
    'wms-external': 'WMS externo',
    'wfs-external': 'WFS externo',
    'esri-rest': 'Esri REST (ArcGIS)',
    'upload': 'Importada',
}

export default{
    name: 'test',
    mixins: [formatter, pagination, restLayer, restGroup, restCategory, userGroupName],
    data(){
        return{
            // null mientras carga: así no se muestra el estado vacío antes
            // de tener la respuesta del backend
            assignedMaps: null,
        }
    },
    components:{
        SideNav,
        Breadcrumb,
        Pagination,
        TabNav
    },
    computed: {
        routesNav: function(){
          const links = [
                {name:'Editar capa' , path: '/capas/' + this.$route.params.idLayer + '/editar-capa'},
                {name:'Asignar mapas' , path: '/capas/' + this.$route.params.idLayer + '/asignar-mapas'},
              ]
          // Sólo ArcGIS admite simbologías; que la capa sea de puntos se
          // comprueba dentro de la vista, contra el servicio.
          if (this.layer.provider && this.layer.provider.name === 'arcgis') {
            links.push({name:'Simbologías' , path: '/capas/' + this.$route.params.idLayer + '/simbologias'})
          }
          links.push({name:'Historial de cambios' , path: '/capas/' + this.$route.params.idLayer + '/historial-de-cambios'})
          links.push({name:'Eliminar capa' , path: '/capas/' + this.$route.params.idLayer + '/eliminar-capa'})
          return links
        },
        routesBread: function(){
          return [
              {name:'Capas', path: '/capas' },
              {name: this.layer.name}
              ]
        },
        providerLabel: function(){
            const name = this.layer.provider && this.layer.provider.name;
            return PROVIDER_LABELS[name] || name || '—';
        },
        calculateAssignedMapsPage: function (){

            if(this.assignedMaps == null) {
                //Si alguna está vacía, no es necesario ejecutar esta función
                return;
            }
            let pageResults = [];

            let skip = this.currentPage > 0 ? ( ( this.currentPage - 1 ) * this.pageSize ) : 0 ;
            for (let i = skip; i < this.assignedMaps.length && i < skip + this.pageSize ; i++) {
                pageResults.push(this.assignedMaps[i])
            }

            //Calcula total de páginas
            if(this.assignedMaps.length <= this.pageSize) {
                this.totalPages = 0;
                return pageResults;
            }
            if ( this.assignedMaps.length % this.pageSize > 0 ) {
                this.totalPages =  Math.floor( (this.assignedMaps.length / this.pageSize) + 1 )
                return pageResults;
            } else {
                this.totalPages = Math.floor( (this.assignedMaps.length / this.pageSize) )
                return pageResults;
            }
        },
    },
    props: [],
    methods:{
        pageChangedClick: function (page){
            this.currentPage = page;
        },
        getCategoryByID: function(){
            const that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/categories/' + this.layer.id_category)
            .then(function (response) {
                that.category = response.data;
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        getAssignedUsers: function(){
            const that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/layers/' + this.$route.params.idLayer + '/maps') //Sin paginación
            .then(function (response) {
                // el backend responde null cuando no hay mapas asignados
                that.assignedMaps = response.data || [];
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
    },
    updated () {

    },
    created () {
        this.$store.getters.getPermissions.layers? true:this.$router.push('/pagina-no-encontrada')
    },
    mounted () {
        this.getGroupsNoPages();
        this.getLayer();
        this.getAssignedUsers();
    },
    watch: {
        'layer': function (newValue, oldValue) {
            if(newValue.id_category){
                this.getCategoryByID();
            }
        },
    }
}
</script>

<style lang="scss" scoped>

.layer-head {
    margin-bottom: 1.25rem;

    &__title {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        flex-wrap: wrap;

        h2 {
            font-size: 1.5rem;
            font-weight: 700;
            color: var(--color-navy);
        }
    }

    &__desc {
        margin-top: 0.35rem;
        color: var(--color-steel);
        font-size: 0.92rem;
        max-width: 70ch;
    }
}

.badge {
    padding: 0.15rem 0.65rem;
    border-radius: 999px;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1.5;

    &--on {
        background: #e8f4ee;
        color: var(--color-success);
    }

    &--off {
        background: var(--color-mist);
        color: var(--color-ghost);
    }
}

.info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 1rem;
    margin-bottom: 1.75rem;
}

.info-card {
    background: var(--color-white);
    border: 1px solid var(--color-line);
    border-radius: 8px;
    padding: 1rem 1.25rem;

    &__title {
        margin: 0 0 0.65rem;
        padding-bottom: 0.5rem;
        border-bottom: 1px solid var(--color-line);
        font-size: 0.78rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: var(--color-steel);
    }

    &__list {
        margin: 0;
    }

    &__row {
        display: grid;
        grid-template-columns: minmax(140px, 35%) 1fr;
        gap: 0.5rem;
        padding: 0.3rem 0;

        dt {
            color: var(--color-ghost);
            font-size: 0.82rem;
            font-weight: 500;
        }

        dd {
            margin: 0;
            font-size: 0.88rem;
            color: var(--color-graphite);
            word-break: break-word;
        }
    }

    &__mono {
        font-family: "IBM Plex Mono", monospace;
        font-size: 0.8rem !important;
    }
}

.maps-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 1.5rem;
    height: 1.5rem;
    padding: 0 0.4rem;
    margin-left: 0.5rem;
    border-radius: 999px;
    background: var(--color-orange-light);
    color: var(--color-orange);
    font-size: 0.8rem;
    font-weight: 700;
    vertical-align: middle;
}

.maps-empty {
    color: var(--color-ghost);
    font-size: 0.9rem;
    padding: 0.5rem 0;
}

.maps-list {
    list-style: none;
    margin: 0 0 0.75rem;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 0.5rem;
}

.maps-list__item {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.55rem 0.85rem;
    border: 1px solid var(--color-line);
    border-radius: 6px;
    background: var(--color-white);
    color: var(--color-graphite);
    font-size: 0.9rem;
    font-weight: 500;
    text-decoration: none;
    transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;

    &:hover {
        border-color: var(--color-steel);
        background: var(--color-mist);
        color: var(--color-navy);
        text-decoration: none;

        .maps-list__go {
            color: var(--color-orange);
            transform: translateX(2px);
        }
    }
}

.maps-list__icon {
    color: var(--color-steel);
    font-size: 0.85rem;
    flex-shrink: 0;
}

.maps-list__name {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.maps-list__go {
    color: var(--color-ghost);
    font-size: 1.1rem;
    line-height: 1;
    transition: color 0.15s ease, transform 0.15s ease;
}

</style>
